import { useState } from "react";
import Modal from "../../../components/ui/Modal";
import { cx } from "../../../utils/classNames";
import ui from "../../../components/ui/ui.module.css";

const MAX_COMMENT = 2000;

const COPY = {
  ACCEPT: {
    title: "Agree with evaluation",
    note: "Agreeing completes the evaluation.",
    label: "Why do you agree?",
    placeholder: "e.g. The ratings reflect my work this period; I'll focus on…",
    confirm: "Agree",
    tone: ui.primary,
  },
  CONTEST: {
    title: "Contest evaluation",
    note: "HR reviews your reason, then either keeps the result or sends it back to your evaluator. If it's sent back, you'll be asked to answer again.",
    label: "Why do you contest? Be specific.",
    placeholder: "e.g. The rating on … doesn't reflect …, because …",
    confirm: "Contest",
    tone: ui.primary,
  },
};

// response: "ACCEPT" | "CONTEST". The comment is required either way.
const AcknowledgeDialog = ({
  response,
  isPending,
  error,
  onConfirm,
  onClose,
}) => {
  const [comment, setComment] = useState("");
  const copy = COPY[response];
  const trimmed = comment.trim();

  return (
    <Modal
      as="form"
      onSubmit={(e) => {
        e.preventDefault();
        if (trimmed) onConfirm(trimmed);
      }}
      title={copy.title}
      onClose={onClose}
      footer={
        <>
          <button
            type="button"
            className={cx(ui.button, ui.secondary)}
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="submit"
            className={cx(ui.button, copy.tone)}
            disabled={isPending || !trimmed}
          >
            {isPending ? "Saving…" : copy.confirm}
          </button>
        </>
      }
    >
      <div className={cx(ui.alert, ui.alertInfo, "mb-3")}>
        <span>{copy.note}</span>
      </div>

      <label htmlFor="ack-comment" className={ui.label}>
        {copy.label} <span className="text-danger">*</span>
      </label>
      <textarea
        id="ack-comment"
        rows={4}
        maxLength={MAX_COMMENT}
        className={cx(ui.input, ui.textarea)}
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        placeholder={copy.placeholder}
        required
        autoFocus
      />
      <small className={ui.hint}>
        {comment.length}/{MAX_COMMENT}
      </small>

      {error && (
        <div className={cx(ui.alert, ui.alertDanger, "mt-3")}>{error}</div>
      )}
    </Modal>
  );
};

export default AcknowledgeDialog;
